import IPT from 'react-immutable-proptypes';
import PT from 'prop-types';
import { Question } from '../../components';
import s from './styles.scss';
import { Element } from 'react-scroll';
import { filterQuestions } from '../../../../utils';
import Immutable from 'immutable';

export const QuestionSection = ({
  section,
  isTeacher,
  exam,
  classId,
  buildQuestionSetUrl,
  questionsBySectionId,
  classQuestionSetAggregates,
  questionResponses,
  getQuestionInstructionText,
  searchParams,
}) => {
  const questions = questionsBySectionId.get(
    `${section.get('id')}`,
    Immutable.List()
  );
  return (
    <Element
      id={`${section.get('id')}`}
      name={`${section.get('id')}`}
      className={s.questionSection}
    >
      {section.get('title') && (
        <header className={s.titleBlock}>
          <div className={s.titleLeft}>{section.get('title')}</div>
          <div className={s.titleRight}>
            {!isTeacher ? (
              <>
                <div>Completed</div>
                <div>Self-reflection</div>
              </>
            ) : (
              <div>Student Responses</div>
            )}
          </div>
        </header>
      )}

      <section data-test="question-list">
        {filterQuestions(questions, searchParams)
          .map((question) => (
            <Question
              key={question.get('id')}
              buildQuestionSetUrl={buildQuestionSetUrl}
              question={question}
              getQuestionInstructionText={getQuestionInstructionText}
              isTeacher={isTeacher}
              classQuestionSetAggregates={classQuestionSetAggregates}
              questionResponses={questionResponses}
              classId={classId}
              examId={exam.get('id')}
              searchParams={searchParams}
            />
          ))
          .toArray()}
      </section>
    </Element>
  );
};

QuestionSection.propTypes = {
  section: IPT.map.isRequired,
  isTeacher: PT.bool.isRequired,
  exam: IPT.map.isRequired,
  buildQuestionSetUrl: PT.func.isRequired,
  questionsBySectionId: IPT.map.isRequired,
  classQuestionSetAggregates: PT.any,
  classId: PT.oneOfType([PT.string, PT.number]).isRequired,
  questionResponses: PT.any.isRequired,
  getQuestionInstructionText: PT.func.isRequired,
  searchParams: PT.object.isRequired,
};
